import React from "react";
import { Bot } from "../types/bot.type";
import RangeSelector from "./RangeSelector";

interface Props {
  bot: Bot;
  updateBot: (bot: Bot) => void;
}

const BuyConfig: React.FC<Props> = ({ bot, updateBot }) => {
  // Generalized update function
  const handleValueChange = (keyName: string, value: number) => {
    let updatedBot;
    if (keyName === "maxOpenTrades") {
      updatedBot = {
        ...bot,
        tradeParameters: {
          ...bot.tradeParameters,
          buy: { ...bot.tradeParameters.buy, maxOpenTrades: value }
        }
      };
    } else if (keyName === "tradeRatio") {
      updatedBot = {
        ...bot,
        tradeParameters: { ...bot.tradeParameters, tradeRatio: value }
      };
    } else {
      // Assuming the first strategy is always the one to be updated
      // For a more dynamic approach, you might need additional logic to select the correct strategy
      const strategies = bot.tradeParameters.buy.strategies.map(
        (strategy, index) => {
          if (index === 0) {
            // This assumes you're always updating the first strategy
            return { ...strategy, threshold: value };
          }
          return strategy;
        }
      );

      updatedBot = {
        ...bot,
        tradeParameters: {
          ...bot.tradeParameters,
          buy: { ...bot.tradeParameters.buy, strategies }
        }
      };
    }
    updateBot(updatedBot);
  };

  return (
    <>
      <RangeSelector
        title="Relative Strength Index (RSI)"
        min={1}
        max={100}
        step={1}
        value={bot?.tradeParameters?.buy?.strategies[0]?.threshold || 30}
        onValueChange={value => handleValueChange("rsiThreshold", value)}
        helpId="buy_rsi"
        isEnabled={true}
      />
      <RangeSelector
        title="Trade Ratio"
        min={1}
        max={100}
        step={1}
        value={bot?.tradeParameters?.tradeRatio || 70}
        onValueChange={value => handleValueChange("tradeRatio", value)}
        helpId="buy_trade_ratio"
        isEnabled={true}
      />
      <RangeSelector
        title="Trade Slots"
        min={0}
        max={10}
        step={1}
        value={bot?.tradeParameters?.buy?.maxOpenTrades || 0}
        onValueChange={value => handleValueChange("maxOpenTrades", value)}
        helpId="buy_trade_slots"
        isEnabled={true}
      />
    </>
  );
};

export default BuyConfig;
